// tableColumnsConfig.js
import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

// 定义所有模块类型
export const MODULES = {
    METAG: 'metag',
    METABO: 'metabo',
    TRANS: 'trans',
    BZ: 'bz',
    SINGLECELL: 'singleCell',
    TRANS_METABO: 'transMetabo',
    BZ_METABO: 'bzMetabo'
};

// 基础列定义
export const projectColumns = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '项目号',
            dataIndex: 'projectsRow.projectId',
            key: 'projectId',
            sorter: true,
            className: 'tdProjectNote',
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'projectId',
            },
            filteredValue: filteredInfo.projectId || [],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '合同号',
            dataIndex: 'projectsRow.contractNumber',
            key: 'contractNumber',
            width: 200,
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'foldInfo'
            },
            filteredValue: filteredInfo.contractNumber || [],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '合同签署状态',
            dataIndex: 'bsSignStatus',
            key: 'bsSignStatus',
            scopedSlots: {
                customRender: 'bsSignStatus'
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '类型',
            dataIndex: 'projectsRow.projectSign',
            key: 'projectSign',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'projectSign'
            },
            filteredValue: filteredInfo.projectSign || [],
            model: [ MODULES.METABO]
        },
        {
            title: '类型',
            dataIndex: 'projectsRow.projectSign',
            key: 'projectSign',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterProjectType',
                filterIcon: 'filterIcon',
                customRender: 'projectSign'
            },
            filteredValue: filteredInfo.projectSign || [],
            model: [MODULES.METAG]
        },
        {
            title: '类型',
            dataIndex: 'projectsRow.projectType',
            key: 'projectType',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'foldInfo'
            },
            filteredValue: filteredInfo.projectType || [],
            model: [MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '项目类型',
            dataIndex: 'projectsRow.projectType',
            key: 'projectType',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'foldInfo'
            },
            filteredValue: filteredInfo.projectType || [],
            model: [MODULES.METAG]
        },
        {
            title: '销售姓名',
            dataIndex: 'salerList',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'salesName'
            },
            filteredValue: filteredInfo.salesName || [],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '客户姓名',
            dataIndex: 'customerList',
            key: 'customerName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customerName'
            },
            filteredValue: filteredInfo.customerName || [],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '分析员姓名',
            dataIndex: 'analyst.name',
            key: 'analystName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
            filteredValue: filteredInfo.analystName || [],
            noPermitRole: ['USER'],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ, MODULES.SINGLECELL]
        },
        {
            title: '样本数量',
            dataIndex: 'sampleNumber',
            key: 'sampleNumber',
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '样本信息',
            dataIndex: 'projectsRow',
            key: 'projectsRow',
            scopedSlots: {
                customRender: 'sampleInfo'
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '创建时间',
            dataIndex: 'projectsRow.createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '报告审批状态',
            dataIndex: 'projectsRow.passApproval',
            key: 'projectsRow.passApproval',
            scopedSlots: {
                customRender: 'passApproval'
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '分析结果状态',
            dataIndex: 'projectsRow.resReleased',
            key: 'projectsRow.resReleased',
            scopedSlots: {
                customRender: 'resReleased'
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '原始数据状态',
            dataIndex: 'projectsRow.rawDataStatus',
            key: 'rawDataStatus',
            scopedSlots: {
                filterDropdown: 'filterRawDataStatus',
                filterIcon: 'filterIcon',
                customRender: 'rawDataStatus',
            },
            filteredValue: filteredInfo.rawDataStatus || [],
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        // BZ特有的合并状态列
        {
            title: '合并状态',
            dataIndex: 'projectsRow.mergeStatus',
            key: 'mergeStatus',
            scopedSlots: {
                filterDropdown: 'filterMergeStatus',
                filterIcon: 'filterIcon',
                customRender: 'mergeStatus',
            },
            filteredValue: filteredInfo.mergeStatus || [],
            model: [MODULES.BZ]
        },
        {
            title: '项目备注',
            dataIndex: 'projectsRow.note',
            key: 'note',
            width: 200,
            scopedSlots: {
                customRender: 'note',
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '备注（客户自填）',
            dataIndex: 'customerRemark',
            key: 'customerRemark',
            width: 200,
            scopedSlots: {
                customRender: 'customNote',
            },
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            model: [MODULES.METAG, MODULES.METABO, MODULES.TRANS, MODULES.BZ]
        }
    ]
}

export const jointProjectColumns = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '项目号',
            dataIndex: 'projectId',
            key: 'query#projectId.CASE_LIKE',
            sorter: true,
            className: 'tdProjectNote',
            sortDirections: ["descend", "ascend", "descend"],
            searchMethod: 'CASE_LIKE',
            scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'projectId'},
            filteredValue: filteredInfo.projectId || [],
        },
        {
            title: '关联信息',
            dataIndex: 'project',
            key: 'project',
            width: 200,
            children: [
                {
                    title: '转录组项目号',
                    dataIndex: 'rnaProjectId',
                    key: 'rnaProjectId',
                    searchMethod: 'CASE_LIKE',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'rnaProjectId'
                    },
                    filteredValue: filteredInfo.rnaProjectId || [],
                }, {
                    title: '转录组样本数量',
                    dataIndex: 'rnaSampleInfo',
                    key: 'rnaSampleNum',
                    scopedSlots: {customRender: 'sampleNum'}
                }, {
                    title: '转录组样本信息',
                    dataIndex: 'rnaSampleInfo',
                    key: 'rnaSampleInfo',
                    scopedSlots: {customRender: 'sampleInfoTrans'}
                },
                {
                    title: '代谢组项目号',
                    dataIndex: 'metProjectId',
                    key: 'metProjectId',
                    searchMethod: 'CASE_LIKE',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'metProjectId'
                    },
                    filteredValue: filteredInfo.metProjectId || [],
                },
                {
                    title: '代谢组样本数量',
                    dataIndex: 'metSampleInfo',
                    key: 'metSampleNum',
                    scopedSlots: {customRender: 'sampleNum'}
                },
                {
                    title: '代谢组样本信息',
                    dataIndex: 'metSampleInfo',
                    key: 'metSampleInfo',
                    scopedSlots: {
                        customRender: 'sampleInfoMetabo'
                    },
                },
            ],
            model: [MODULES.TRANS_METABO]
        },
        {
            title: '关联信息',
            dataIndex: 'project',
            key: 'project',
            width: 200,
            children: [
                {
                    title: '多样性项目号',
                    dataIndex: 'ampProjectId',
                    key: 'ampProjectId',
                    searchMethod: 'CASE_LIKE',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'ampProjectId'
                    },
                    filteredValue: filteredInfo.ampProjectId || [],
                },
                {
                    title: '多样性样本数量',
                    dataIndex: 'ampSampleInfo',
                    key: 'ampSampleNum',
                    scopedSlots: {customRender: 'sampleNum'}
                },
                {
                    title: '多样性样本信息',
                    dataIndex: 'ampSampleInfo',
                    key: 'ampSampleInfo',
                    scopedSlots: {
                        customRender: 'sampleInfoBz'
                    },
                },
                {
                    title: '代谢组项目号',
                    dataIndex: 'metProjectId',
                    key: 'metProjectId',
                    searchMethod: 'CASE_LIKE',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'metProjectId'
                    },
                    filteredValue: filteredInfo.metProjectId || [],
                },
                {
                    title: '代谢组样本数量',
                    dataIndex: 'metSampleInfo',
                    key: 'metSampleNum',
                    scopedSlots: {customRender: 'sampleNum'}
                },
                {
                    title: '代谢组样本信息',
                    dataIndex: 'metSampleInfo',
                    key: 'metSampleInfo',
                    scopedSlots: {
                        customRender: 'sampleInfoMetabo'
                    },
                },

            ],
            model: [MODULES.BZ_METABO]
        },
        {
            title: '销售姓名',
            dataIndex: 'sales',
            key: 'salesName',
            scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'salesName'},
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '客户姓名',
            dataIndex: 'customerInfos',
            key: 'customerName',
            scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'customerName'},
            filteredValue: filteredInfo.customerName || [],
        },
        {
            title: '创建人',
            dataIndex: 'creator',
            key: 'creator',
            sorter: true,
            scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'customerCreator'},
            filteredValue: filteredInfo.creator || [],
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {title: '项目备注', dataIndex: 'remark', key: 'remark', width: 200, scopedSlots: {customRender: 'remark'}},
        {
            title: '备注（客户自填）',
            dataIndex: 'customerRemark',
            key: 'customerRemark',
            width: 200,
            scopedSlots: {customRender: 'customerRemark'}
        },
        {title: '操作', key: 'operation', scopedSlots: {customRender: 'operation'}, width: 200}
    ]
}
